import { motion } from "framer-motion";
import { ArrowDownRight } from "lucide-react";
import SectionHeading from "./SectionHeading";
import { USE_CASES } from "../data/site";

export default function UseCases() {
  return (
    <section className="bg-white py-24 md:py-32" data-testid="use-cases-section">
      <div className="container-x">
        <SectionHeading
          eyebrow="Use cases"
          title="Where our work creates value."
          subtitle="Real problems, engineered solutions, and the outcomes they enable."
          max="max-w-3xl"
        />
        <div className="mt-16 grid gap-5 md:grid-cols-2 lg:grid-cols-3">
          {USE_CASES.map((u, i) => (
            <motion.div
              key={u.title}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: (i % 3) * 0.08, ease: [0.16, 1, 0.3, 1] }}
              className="group flex flex-col rounded-3xl border border-slate-200 bg-[#F8FAFC] p-7 transition-all duration-500 hover:-translate-y-1.5 hover:bg-white hover:shadow-[0_30px_60px_-30px_rgba(7,17,31,0.22)]"
              data-testid={`use-case-${i}`}
            >
              <h3 className="font-display text-lg font-medium text-[#07111F]">{u.title}</h3>
              <div className="mt-5 space-y-4 text-sm">
                {[["Problem", u.problem], ["Solution", u.solution], ["Outcome", u.outcome]].map(([k, v]) => (
                  <div key={k}>
                    <span className="overline text-slate-400">{k}</span>
                    <p className="mt-1 leading-relaxed text-slate-600">{v}</p>
                  </div>
                ))}
              </div>
              <ArrowDownRight className="mt-6 text-slate-300 transition-colors duration-500 group-hover:text-[#07111F]" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
